/* eslint-disable implicit-arrow-linebreak */
import Container from 'components/Containers/Container';
import Card from 'components/Containers/Card';
import { Col, Row } from 'antd';
import Book from 'modules/Book/components/Book';
import allBooks from 'modules/Book/components/allBooks';
import OfflineContainer from '../OfflineContainer';

type BookType = {
  id: number;
  imageUrl: string;
  externalLink: string;
  title: string;
  subTitle: string;
  description: string;
  sortOrder: number;
  schoolTypeId: number;
  classId: number;
  bookType: string;
  isOld?: boolean;
};

const Books = () => {
  const books = allBooks.filter((book) => !book.isOld);

  const moveToBook = (item: BookType) => {
    window.open(`${item.externalLink}`, '_blank');
  };

  // useEffect(() => {
  //   const active = getActiveBooks(data?.data?.data ?? []);
  //   setBooks(active);
  // }, [data, classCurrent]);

  return (
    <>
      <Row gutter={[24, 24]}>
        {books?.map((item) => {
          return (
            <Col key={`book-${item.id}`} xxl={6} lg={8} md={8} sm={12} xs={24}>
              <Book item={item} onClick={() => moveToBook(item)} />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default function OfflineBooks() {
  return (
    <OfflineContainer onlineUrl='/lms/student/books'>
      <Container
        name='Sách điện tử'
        parentName='Sách số'
        containerProps={{
          style: {
            // 20px on small screens, children's max width of 1200px on larger screens
            paddingLeft: 'max(20px, calc(20px + (100vw - 1200px) / 2))',
            paddingRight: 'max(20px, calc(20px + (100vw - 1200px) / 2))',
          },
        }}
      >
        <Card title='Danh sách sách điện tử'>
          <Books />
        </Card>
      </Container>
    </OfflineContainer>
  );
}
